module.exports = __webpack_public_path__ + "static/media/HSBC_Logo_White.43a62bb4.svg";